import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Quote } from "lucide-react";

export default function Testimonial() {
  const { t } = useTranslation();
  const items = t('testimonial.items', { returnObjects: true }) as Array<{ quote: string; author: string }>;

  return (
    <section id="testimonial" className="py-24 bg-surface-container-low border-y border-outline-variant scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-16 text-center">{t('testimonial.title')}</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
              className="bg-white border border-outline-variant border-l-4 border-l-primary-container p-8 rounded-xl"
            >
              <Quote className="w-8 h-8 text-primary-container/30 mb-4" />
              <blockquote className="text-on-surface leading-relaxed mb-6">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <p className="text-on-surface-variant text-sm font-medium">&mdash; {item.author}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
